// Case-insensitive substring match against the item's title and any extra
// `keywords` (a string or array of strings). Keywords let a host make an item
// findable by text it does not display — e.g. an ASCII-folded "Jose" carried for
// a "José" whose title keeps its diacritics.
export function itemMatchesQuery(item, query, getItemTitle) {
  if (getItemTitle(item)?.toLowerCase().includes(query)) {
    return true;
  }
  const { keywords } = item ?? {};
  if (keywords == null) {
    return false;
  }
  const list = Array.isArray(keywords) ? keywords : [keywords];
  return list.some((keyword) => typeof keyword === "string" && keyword.toLowerCase().includes(query));
}

// Normalise an item's `keywords` (string | array | absent) to a string array.
export function keywordList(item) {
  const { keywords } = item ?? {};
  if (keywords == null) {
    return [];
  }
  return (Array.isArray(keywords) ? keywords : [keywords]).filter((keyword) => typeof keyword === "string");
}

// Coerce a `maxResults` value (number | numeric string | undefined) to a positive
// integer cap, or null for "no limit".
export function normalizeLimit(maxResults) {
  const n = Number(maxResults);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
}
